module.exports = __webpack_public_path__ + "img/result-detail-communication-outleft03.51ebe6ec.svg";